import { render } from "./MobileToDoItem.vue?vue&type=template&id=0f0aced6&scoped=true"
import script from "./MobileToDoItem.vue?vue&type=script&lang=js"
export * from "./MobileToDoItem.vue?vue&type=script&lang=js"

import "./MobileToDoItem.vue?vue&type=style&index=0&id=0f0aced6&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0aced6"]])

export default __exports__